import { useSipBroadcast } from "@/components/SIPIntegration/composables/useSipBroadcast";

export interface UseSipCommandsReturn {
  dial: (n: string) => void;
  answer: () => void;
  hangup: () => void;
  dtmf: (t: string) => void;
  setPause: (r: string) => void;
  focus: () => void;
}

export function useSipCommands(): UseSipCommandsReturn {
  const bc = useSipBroadcast();
  return {
    dial: (n) => bc.postCommand("dial", n),
    answer: () => bc.postCommand("answer"),
    hangup: () => bc.postCommand("hangup"),
    dtmf: (t) => bc.postCommand("dtmf", t),
    setPause: (r) => bc.postCommand("setPause", r),
    focus: () => bc.postCommand("focus"),
  };
}
